import { AppLayoutComponent } from '../theme/app-layout/app-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGuard } from '@core';
import { Role } from '@core/authentication/auth.roles';
import { ReportComponent } from '@shared/components/report/report.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    component: AppLayoutComponent,
    children: [
      {
        path: 'energy',
        canActivateChild: [RoleGuard],
        data: {
          roles: [Role.Standard],
        },
        children: [
          {
            path: 'bhkw',
            component: ReportComponent,
            data: { report: 'bhkw' },
          },
          {
            path: 'development',
            component: ReportComponent,
            data: { report: 'energyDevelopment' },
          },
          {
            path: 'smops',
            component: ReportComponent,
            data: { report: 'smops' },
          },
          {
            path: 'bhkw',
            redirectTo: 'general',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'info',
        loadChildren: () => import('./info/info.module').then(m => m.InfoModule),
      },
      {
        path: 'monitoring',
        canActivateChild: [RoleGuard],
        data: {
          roles: [Role.Reporting],
        },
        children: [
          {
            path: 'actual-target',
            component: ReportComponent,
            data: { report: 'actualTarget' },
          },
          {
            path: 'import-status',
            component: ReportComponent,
            data: { report: 'importStatus' },
          },
          {
            path: 'pue',
            component: ReportComponent,
            data: { report: 'pue' },
          },
          {
            path: '',
            redirectTo: 'actual-target',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'overview',
        canActivateChild: [RoleGuard],
        data: {
          roles: [Role.Standard],
        },
        children: [
          {
            path: '',
            component: ReportComponent,
            data: { report: 'overviewTotal' },
          },
          {
            path: 'smp',
            component: ReportComponent,
            data: { report: 'overviewSmp' },
          },
        ],
      },
      {
        path: 'reports',
        canActivateChild: [RoleGuard],
        data: {
          roles: [Role.Reporting],
        },
        children: [
          {
            path: 'general',
            component: ReportComponent,
            data: { report: 'generalReport' },
          },
          {
            path: 'zero-hour-load',
            component: ReportComponent,
            data: { report: 'zeroHourLoad' },
          },
          {
            path: 'profile-analysis',
            component: ReportComponent,
            data: { report: 'profileAnalysis' },
          },
          {
            path: '',
            redirectTo: 'general',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'settings',
        canActivateChild: [RoleGuard],
        data: {
          roles: [Role.Settings],
        },
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
      },
      {
        path: 'total-load',
        component: ReportComponent,
        canActivate: [RoleGuard],
        data: { report: 'totalLoad', roles: [Role.Standard] },
      },
      {
        path: 'consumption-points',
        canActivateChild: [RoleGuard],
        data: {
          roles: [
            Role.Standard,
            Role.Locations_Dfmg,
            Role.Locations_T_Systems,
            Role.Locations_Whitelist,
          ],
        },
        loadChildren: () =>
          import('./consumption-points/consumption-points.module').then(
            m => m.ConsumptionPointsModule
          ),
      },
      {
        path: 'data-privacy',
        loadChildren: () =>
          import('./data-privacy/data-privacy.module').then(m => m.DataPrivacyModule),
      },
      {
        path: 'release-notes',
        loadChildren: () =>
          import('./release-notes/release-notes.module').then(m => m.ReleaseNotesModule),
      },
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'sessions',
    loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule),
    data: { title: 'Sessions', titleI18n: 'sessions' },
  },
  { path: '**', redirectTo: 'overview' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class RoutesRoutingModule {}
